import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Container, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { setAlert } from 'src/layouts/main/MainLayoutSlice';
import { getRegionBySlug, resetPassword } from 'src/pages/CareerHistory/CareerHistorySlice';
import { base_route_url, EMAIL_REGEXP } from 'src/utils';
import * as Yup from 'yup';
import AuthWrapper from './AuthWrapper';
import FormTextField from './FormTextField';

const ForgotPassword = () => {
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .required('Email is required')
      .matches(EMAIL_REGEXP, 'Email format is not valid'),
  });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: '',
    },
  });

  const navigate = useNavigate();
  const params = useParams();
  const isRegion = !!params?.rg_name;
  const collegeDetails = useSelector((state) => state.mainLayout.collegeDetails);
  const collegeId = collegeDetails?._id;
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const { cg_name, rg_name } = useParams();

  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);
  const regions = useSelector((state) => state.careerHistory.regions);
  const handleBackSignin = () => {
    if (cg_name) {
      navigate(`${base_route_url}${params?.cg_name}/sign-in`);
    } else {
      navigate(`${base_route_url}region/${params?.rg_name}/sign-in`);
    }
  };
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto'; // reset on unmount
    };
  }, []);
  useEffect(() => {
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);
  const onSubmit = (values) => {
    setIsLoading(true);
    dispatch(resetPassword(values))
      .then((res) => {
        const data = res?.payload?.data;
        if (data?.success) {
          dispatch(
            setAlert({
              open: true,
              isSuccess: true,
              type: 'success',
              msg: get(res, 'payload.data.message')
                ? get(res, 'payload.data.message')
                : 'successfully sent reset code',
            })
          );
          reset();
          handleBackSignin();
        } else {
          const errorMessage =
            get(res, 'payload.response.data.message') ||
            'Something Went Wrong, Please try again later';
          dispatch(
            setAlert({
              open: true,
              msg: errorMessage,
            })
          );
        }
      })
      .finally(() => setIsLoading(false));
  };
  const buttonColor = collegeDetails?.region?.button?.bgColor || regions?.button?.bgColor;
  const buttonFontColor = collegeDetails?.region?.button?.color || regions?.button?.color;
  const fontColor = collegeDetails?.region?.fontColor || regions?.fontColor;
  const bgImage = regions?.bgImage || collegeDetails?.region?.bgImage;
  return (
    <AuthWrapper title="Reset-Password">
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '78vh',
          paddingBlock: { xs: 2, sm: 3, md: 3 },
        }}
        className="page-content-wrapper"
      >
        <Container>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant='h1'
              sx={{ fontSize: '32px !important', mb: 2, mt: { lg: 2, sm: 0 }, color: fontColor }}
            >
              <b>Reset Password</b>
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: {
                  xs: '100%', // full width on extra-small screens
                  sm: 600, // 500px on small screens
                  md: 600, // 600px on medium screens
                  lg: 700, // 700px on large screens
                  xl: 800, // 800px on extra-large screens
                },
                backgroundColor: 'white',
                py: 4,
                borderRadius: '8px',
              }}
            >
              <form onSubmit={handleSubmit(onSubmit)} style={{width:'100%',padding:'10px'}}>
                <Box className="sign-up-wrapper" sx={{width:'100%'}}>
                  <FormTextField
                    title="Email Address"
                    isRequired
                    name="email"
                    placeholder="Enter email"
                    {...register('email')}
                    control={control}
                    fullWidth
                    className="input-text-field"
                  />
                </Box>
                <LoadingButton
                  sx={{
                    backgroundColor: (theme) =>
                      `${buttonColor || theme.palette.primary.main} !important`,
                    borderRadius: '8px',
                    color: buttonFontColor || 'white',
                    // width: '80%',
                    p: 2,
                    my: 1,
                  }}
                  fullWidth
                  type="submit"
                  loading={isLoading}
                  // onClick={(e) => showCareerDetailsPopup(item.id, e)}
                >
                  Send Reset Code
                </LoadingButton>
                <LoadingButton
                  sx={{
                    // backgroundColor: (theme) =>
                    //   `${buttonColor || theme.palette.primary.main} !important`,
                    borderRadius: '8px',
                    borderColor: buttonColor,
                    color: buttonFontColor || 'white',
                    // width: '80%',
                    p: 2,
                    my: 1,
                  }}
                  variant="outlined"
                  fullWidth
                  onClick={handleBackSignin}
                >
                  Back to sign in
                </LoadingButton>
              </form>
            </Box>
          </Box>
        </Container>
      </Box>
    </AuthWrapper>
  );
};

export default ForgotPassword;
